import 'moment-timezone' // MUST be first — initializes moment.tz() globally before any component uses it
import 'common-tools/suppressReactWarnings'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { createPortal } from 'react-dom'
import { Redirect, globalHistory } from '@reach/router'
import Login from 'common-views/Security/Login'
import DrawerContainer from 'common-views/Drawer/DrawerContainer'
import UnknownRoute from 'common-views/Security/UnknownRoute'
import { store } from 'common-data/store'
import { Provider as ReduxProvider } from 'react-redux'
import { RoutePush } from 'common-data/Actions/ReduxRouterActions'
import ReduxToastr from 'react-redux-toastr'
import { StaticRouter } from 'common-classes/Poses/index'
import styles from './main.less'
import { AppRoute } from './approute'
import 'chart.js'

// const pace = require('pace')

globalHistory.listen((history) => {
  store.dispatch(RoutePush(history.location.pathname, history.location.search, history.location.hash))
})

// pace.start()

class Main extends React.Component {
  render () {
    return (
      <React.Fragment>
        <div className={styles.root}>
          <StaticRouter uri='/'>
            <Redirect from="/" to="App/SelfService/Dashboard" />
            <Login path='Login' />
            <AppRoute path='App/*' />
            <UnknownRoute default skipRoutes={['/App']}/>
          </StaticRouter>
        </div>
        <DrawerContainer />
        {/* Render toastr into document.body via a portal so it is always
            on top of every stacking context, including the drawer backdrop */}
        {createPortal(
          <ReduxToastr
            timeOut={4000}
            newestOnTop={false}
            preventDuplicates
            position="bottom-left"
            transitionIn="fadeIn"
            transitionOut="fadeOut"
            progressBar
            closeOnToastrClick />,
          document.body
        )}
      </React.Fragment>
    )
  }
}

const container = document.getElementById('content')
const root = ReactDOM.createRoot(container)
root.render(
  <ReduxProvider store={store}>
    <Main />
  </ReduxProvider>
)
